<template>
  <div>
    <v-btn
      v-if="isLoggedIn"
      text
      @click.stop="drawer = !drawer"
      :ripple="false"
      class="show-menu"
    >
      <v-icon size="30">mdi-menu</v-icon>
    </v-btn>

    <v-navigation-drawer
      v-model="drawer"
      temporary
      absolute
    >
      <v-list class="mt-4">
        <template v-for="(item, i) in items">
          <v-list-item
            v-if="item.visible"
            :key="i + 'item'"
            :to="item.to"
            link
            @click="
              drawer = false
              $emit('modelValue', false)
            "
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',

  props: {
    isLoggedIn: Boolean
  },

  data: () => ({
    drawer: false
  }),

  computed: {
    ...mapGetters('user', ['adminRole']),

    items() {
      const routeItems = [
        {
          title: this.$t('main.btn.scheduleList'),
          to: '/schedule-list',
          visible: true
        },
        {
          title: this.$t('main.btn.mergedSchedule'),
          to: '/filter-schedule',
          visible: true
        },
        {
          title: this.$t('main.btn.studentSchedule'),
          to: '/schedule'
        },
        {
          title: this.$t('assessmentGenerated.title'),
          to: '/assessment-list',
          visible: true
        }
      ]

      if (this.adminRole) {
        routeItems.push(
          {
            title: this.$t('main.btn.studyCalendar'),
            to: '/study-calendar',
            visible: true
          },
          {
            title: this.$t('main.btn.subgroup'),
            to: '/dictionary/subgroup',
            visible: this.adminRole
          },
          {
            title: this.$t('main.btn.disciplineOriginal'),
            to: '/discipline-original',
            visible: this.adminRole
          },
          {
            title: this.$t('main.btn.disciplineGenerated'),
            to: '/discipline-generated',
            visible: this.adminRole
          }
        )
      }
      return routeItems
    }
  }
}
</script>

<style scoped>
.show-menu::before {
  background-color: transparent !important;
}
</style>
